




























































































































































































































































































































































/** @format */
import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import CustomerInfo from '../compontents/CustomerInfo.vue';
import ControlCarInfo from '../compontents/ControlCarInfo.vue';
import ParkingInfo from '../compontents/ParkingInfo.vue';
import * as routeNames from '../router-names';
import * as _ from 'lodash';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import { queryParkingSpaceAddUpdate } from '@/api/parking-space-list';
import {
  queryMonthCardBuy,
  queryMonthCardCacuteTime,
  querySpacePackageSelectList,
  querySpaceSelectList,
  quertMonthCardDetail,
  quertMonthCardRenew,
  getPlate,
  masterSlave,
  monthCardCheckOut
} from '@/api/fixed-car-management';
import moment from 'moment';
import Utils from '@root/utils/common';
import { carPlateReg } from '@root/utils/validator-util';
import { carTypesMap } from '@/types/order-management/dictionaries';
import { Getter } from 'vuex-class';
import AddStall from './compontents/addstall.vue';
import { PROPERTY_CAR_LIST } from '../router-names';
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import ImageUploader from '@/components/img-upload/index.vue';
import { API_SERVER } from '@root/common/config';
import UserZhongtian from './compontents/user-zhongtian.vue';
import UserInfo from './compontents/user.vue';
import { isChangcheng, isShiDaill } from '@root/utils/env';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: {
    CustomerInfo,
    ControlCarInfo,
    ParkingInfo,
    ParkingLotSearch,
    AddStall,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    },
    ImageUploader,
    UserInfo: window.VUE_APP_SERVER_CONFIG.APP_ENV === 'zhongtian' ? UserZhongtian : UserInfo
  }
})
export default class LongNewCard extends Vue {
  //判断是否是时代邻里
  isshidaill: boolean = isShiDaill;
  locale = zhCN;
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  get title() {
    let title = '';
    if (this.filterParam.useType === '02') {
      // 长租车
      if (this.filterParam.cardId) {
        // 续费
        title = '长租车续费';
      } else {
        // 新办
        title = '新办月卡';
      }
    } else {
      // 产权车
      if (this.filterParam.cardId) {
        // 续费
        if (this.isDetail) {
          title = '产权车详情';
        } else {
          title = '产权车缴费';
        }
      } else {
        // 新办
        title = '新办产权车';
      }
    }
    return title;
  }

  get navs() {
    return [
      {
        label: this.filterParam.useType === '02' ? '长租车业务办理' : '产权车业务办理',
        location: {
          name: this.filterParam.useType === '02' ? routeNames.LONG_RENTAL_CAR_BUSSINESS : routeNames.PROPERTY_CAR_LIST
        }
      },
      {
        label: this.title
      }
    ];
  }

  /**
   * 支付方式
   */
  @Getter('dictionaries/newCardPaymentPayType')
  newCardPaymentPayType?: any;
  get traderecordPayMethodsList() {
    if (this.isChangCheng) {
      return Utils.toLabelVal(this.newCardPaymentPayType);
    } else {
      return _.filter(Utils.toLabelVal(this.newCardPaymentPayType), function(o) {
        o.label = `${o.label}`;
        return o.value != '02' && o.value != '03';
      });
    }
  }
  carTypesList = Utils.toLabelVal(carTypesMap);
  dateFormat = 'YYYY-MM-DD';
  get operateTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [moment(this.filterParam.startDate, 'YYYY-MM-DD'), moment(this.filterParam.endDate, 'YYYY-MM-DD')];
    } else if (this.filterParam.startDate) {
      return [moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  private moment = moment;

  data() {
    return {
      form: this.$form.createForm(this, { name: 'month-card-create' })
    };
  }

  // 新增类型
  // 要上传的数据
  filterParam: any = {
    userId: '',
    cardId: '',
    parkId: '',
    useType: '', // 车位用途 01:产权 02:出租
    packageId: '', // 套餐Id
    monthCardPackageIndex: null, // 选取套餐的索引
    parkingSpaceIndex: [],
    spaceIdList: [], // 车位ID数组
    spaceId: '', // 车位I
    period: 1, // 本次授权周期
    userName: '', //姓名
    roomNum: '', //房间号
    company: '', //单位
    phoneNum: '', //联系电话
    cardNum: '', //身份证号
    startDate: moment(new Date(), 'YYYY-MM-DD'), //开始日期
    endDate: '', // 结束日期
    payType: '', //支付方式
    price: '', // 价格
    plateList: [
      {
        plate: '',
        carType: '01',
        brand: '',
        color: '',
        checked: false,
        masterCar: '00'
      }
    ],
    desc: '', //备注
    waitingPay: '' //支付场景
  };

  //  错误信息
  errorMsg = {
    parkId: {
      validateStatus: '',
      help: ''
    },
    packageId: {
      validateStatus: '',
      help: ``
    }, // 套餐Id
    spaceId: {
      validateStatus: '',
      help: ``
    }, // 车位I
    period: {
      validateStatus: '',
      help: ``
    }, // 本次授权周期
    userName: {
      validateStatus: '',
      help: ``
    }, //姓名
    phoneNum: {
      validateStatus: '',
      help: ``
    }, //联系电话
    timeDate: {
      validateStatus: '',
      help: ``
    }, // 结束日期
    waitingPay: {
      validateStatus: '',
      help: ``
    }, //支付场景
    plateList: [
      {
        plate: '',
        carType: '01',
        brand: '',
        color: ''
      }
    ],
    //身份证号码
    cardNum: {
      validateStatus: '',
      help: ''
    }
  };
  // 默认车牌所在地
  defaultPlate: any = '';
  defaultMasterCar: any = '00';
  // 月卡套餐列表
  private monthCardPackage: any = [];
  // 车位信息
  private parkingSpace: any = [];
  // Authorized vehicles 授权车辆，后面可能要修改
  private authorizedVehicles: any = [
    {
      plate: '',
      carType: '',
      carBrand: '',
      carColor: ''
    }
  ];
  // eslint-disable-next-line getter-return
  get getSpaceList() {
    let spaceIdlist: any;
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    const arr: any = [];
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          arr.push(items);
        }
      });
    });
    if (arr.length > 0) {
      this.monthCardCacuteTimeDebounce(this.filterParam.period, null);
    }
    return arr;
  }
  get getSpaceNameList() {
    let spaceIdlist: any,
      spaceIdName: any = [];
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    const arr: any = [];
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          arr.push(items);
        }
      });
    });
    arr.forEach((items: any) => {
      spaceIdName.push(items.category);
    });
    spaceIdName = Array.from(new Set(spaceIdName));
    return spaceIdName;
  }

  get getSpaceListNum() {
    let spaceIdlist: any;
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    let num: number = 0;
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          num = Number(items.number) + num;
        }
      });
    });
    return num || '';
  }
  /*
   *
   * 生命周期
   * */
  private monthCardCacuteTimeDebounce: any = null;
  private created() {
    this.monthCardCacuteTimeDebounce = _.debounce(this.monthCardCacuteTime, 800);
    this.init();
    // 获取车位
    // this.spaceSelectList()
  }

  private isDetail = false;
  // 初始化数据
  private init() {
    if (this.$route.query.isDetail) {
      this.isDetail = true;
    } else {
      this.isDetail = false;
    }
    this.filterParam.cardId = (this.$route.query.cardId as string) || '';
    this.filterParam.useType = this.$route.query.useType as string;
    this.filterParam.waitingPay = '01';
  }

  // 初始化接口 获取月卡套餐
  private async spacePackageSelectList() {
    const load: any = this.$message.loading('正在加载月卡套餐', 0);
    try {
      const { parkId, useType } = this.filterParam;
      const { status, msg, data = [] } = await querySpacePackageSelectList({
        parkId,
        useType
      });
      if (status === '9999' && data.length > 0) {
        this.monthCardPackage = data;
        this.filterParam.monthCardPackageIndex = 0;
        this.parkingSpace = [];
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
      } else {
        this.monthCardPackage = [];
        this.parkingSpace = [];
        this.filterParam.monthCardPackageIndex = null;
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
        this.$message.error('未查询到在售中的收费套餐');
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      load();
    }
  }
  //获取勾选的主车个数
  get checkedNum() {
    let count = 0;
    for (var i = 0; i < this.filterParam.plateList.length; i++) {
      if (this.filterParam.plateList[i].checked) count++;
    }
    return count;
  }

  isChangCheng: boolean = isChangcheng;
  /**
   * 提交信息
   */
  private isSub = false;
  //有uerId和cardId的保存方法
  async submitHasCardId(submitJson: string, flag: boolean, callback: { (): void; (): void; (): void }) {
    if (this.isSub) return;
    this.isSub = true;
    let load: any = '';
    if (flag) {
      load = this.$message.loading('正在提交信息，请稍等');
    }
    try {
      const { status, msg, data } = await quertMonthCardRenew(submitJson);
      if (status === '9999') {
        this.$message.success(data);
        this.$router.replace({
          name: this.filterParam.useType === '02' ? routeNames.LONG_RENTAL_CAR_BUSSINESS : routeNames.PROPERTY_CAR_LIST
        });
        this.goBack();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      this.$message.error(e.msg || '系统繁忙请稍后再试');
    } finally {
      this.isSub = false;
      if (flag) {
        load();
      }
      callback();
    }
  }
  //无 cardId
  async submitNoCardId(submitJson: string, flag: boolean, callback: { (): void; (): void; (): void }) {
    if (this.isSub) return;
    this.isSub = true;
    let load: any = '';
    if (flag) {
      load = this.$message.loading('正在提交信息，请稍等');
    }
    try {
      const { status, msg, data } = await queryMonthCardBuy(submitJson);
      if (status === '9999') {
        this.$message.success(data);
        this.$router.replace({
          name: this.filterParam.useType === '02' ? routeNames.LONG_RENTAL_CAR_BUSSINESS : routeNames.PROPERTY_CAR_LIST
        });
        this.goBack();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      this.$message.error(e.msg || '系统繁忙请稍后再试');
    } finally {
      this.isSub = false;
      if (flag) {
        load();
      }
      callback();
    }
  }

  disabledDate(current: any) {
    return (
      current &&
      current <
        moment()
          .endOf('day')
          .subtract(1, 'day')
    );
  }

  private submitClick(e) {
    e.preventDefault();
    this.form.validateFields(async (error, values) => {
      let {
        useType,
        parkId,
        packageId,
        spaceIdList,
        spaceId,
        plateList,
        period,
        startDate,
        endDate,
        payType,
        price,
        cardId,
        desc,
        userId,
        company,
        waitingPay
      } = this.filterParam;

      if (this.filterParam.useType === '01') {
        if (spaceId) {
          spaceIdList.push(spaceId);
        }
      }

      spaceIdList = Array.from(new Set(spaceIdList));

      if (!parkId) {
        this.errorMsg.parkId.help = '车场必填';
        this.$message.error('车场必填');
        this.errorMsg.parkId.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.parkId.help = '';
        this.errorMsg.parkId.validateStatus = '';
      }

      if (!packageId) {
        this.errorMsg.packageId.help = '套餐必填';
        this.$message.error('套餐必填');
        this.errorMsg.packageId.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.packageId.help = '';
        this.errorMsg.packageId.validateStatus = '';
      }

      if (spaceIdList.length === 0) {
        this.errorMsg.spaceId.help = '车位号必填';
        this.$message.error('车位号必填');
        this.errorMsg.spaceId.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.spaceId.help = '';
        this.errorMsg.spaceId.validateStatus = '';
      }

      if (!period) {
        this.errorMsg.period.help = '授权周期必填';
        this.$message.error('授权周期必填');
        this.errorMsg.period.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.period.help = '';
        this.errorMsg.period.validateStatus = '';
      }

      if (!startDate || !endDate) {
        this.errorMsg.timeDate.help = '授权日期必填';
        this.$message.error('授权日期必填');
        this.timeDate.phoneNum.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.timeDate.help = '';
        this.errorMsg.timeDate.validateStatus = '';
      }
      if (!waitingPay) {
        this.errorMsg.waitingPay.help = '请选择支付场景';
        this.$message.error('请选择支付场景');
        this.errorMsg.waitingPay.validateStatus = 'error';
        return;
      } else {
        this.errorMsg.waitingPay.help = '';
        this.errorMsg.waitingPay.validateStatus = '';
      }
      if (waitingPay == '01' && !payType) return this.$message.error('请选择支付方式');
      startDate = moment(startDate).format('YYYY-MM-DD');
      const platecopy = [];
      for (let i = 0; i < plateList.length; i++) {
        platecopy.push(plateList[i].plate);
        if (!plateList[i].plate) {
          // return this.$message.error(`请输入授权车辆，第 ${i + 1} 项的车牌`)
        } else if (!carPlateReg.test(plateList[i].plate)) {
          return this.$message.error(`授权车辆，第 ${i + 1} 项的车牌输入有误`);
        }
      }

      function isUniqueArr(arrs: any[]) {
        const arrToStr = arrs.join(',') + ',';
        for (let i = 0; i < arrs.length; i++) {
          //ps:替换为空，还能发现元素，证明有重复元素
          if (arrToStr.replace(arrs[i] + ',', '').indexOf(arrs[i] + ',') > -1) {
            return false;
          }
        }
        return true;
      }
      if (!isUniqueArr(platecopy)) return this.$message.error('车牌号不能重复');

      if (this.checkedNum > this.getSpaceListNum)
        return this.$message.error(`最多勾选的主车数量不得超过月卡的泊车数量`);

      if (
        this.isChangCheng &&
        this.moment(endDate)
          .add(1, 'day')
          .diff(this.moment(startDate), 'months') /
          Number(this.monthCardPackage[this.filterParam.monthCardPackageIndex].periodNum) <
          1
      ) {
        return this.$message.error('授权期限不可小于一个套餐周期，且需为整月或截止到自然月月末。请确认重试。');
      }
      if (
        this.isChangCheng &&
        moment(endDate)
          .endOf('month')
          .format('YYYY-MM-DD') !== moment(endDate).format('YYYY-MM-DD')
      ) {
        if (moment(startDate).date() - 1 !== moment(endDate).date()) {
          return this.$message.error('授权期限不可小于一个套餐周期，且需为整月或截止到自然月月末。请确认重试。');
        }
      }
      if (this.isSub) return;
      if (error) return;

      this.isSub = true;
      const load: any = this.$message.loading('正在提交信息，请稍等');
      const json = { parkId, cardId, plateList };
      const _self = this;

      let submitJson = {
        useType,
        parkId,
        packageId,
        spaceIdList,
        plateList,
        period,
        startDate,
        endDate,
        payType,
        price,
        desc,
        company,
        ...values
      };
      submitJson.waitingPay = waitingPay == '02';
      if (this.images && this.images.length) {
        submitJson.photos = [...this.images];
      }
      submitJson = JSON.stringify(submitJson);

      try {
        const { data } = await monthCardCheckOut(json);
        _self.isSub = false;
        if (data) {
          load();
          this.$confirm({
            title: '提示',
            content: data,
            onOk() {
              if (cardId && userId) {
                _self.submitHasCardId(submitJson, true, function() {});
              } else {
                _self.submitNoCardId(submitJson, true, function() {});
              }
            },
            onCancel() {}
          });
        } else {
          if (cardId && userId) {
            _self.submitHasCardId(submitJson, false, function() {
              load();
            });
          } else {
            _self.submitNoCardId(submitJson, false, function() {
              load();
            });
          }
        }
        this.form.resetFields();
      } catch (error) {
        _self.$message.error(error.msg || '系统繁忙，请稍后再试');
      } finally {
        _self.isSub = false;
        load();
      }
    });
  }

  /**
   * 获取车位信息
   */
  private async spaceSelectList() {
    const load: any = this.$message.loading('正在加载车位信息', 0);
    try {
      const { parkId, useType, packageId } = this.filterParam;
      const { status, msg, data = [] } = await querySpaceSelectList({
        parkId,
        useType,
        packageId
      });
      if (status === '9999' && data.length > 0) {
        this.parkingSpace = data;
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [data[0].spaceId];
        } else {
          this.filterParam.spaceId = data[0].spaceId;
        }
      } else {
        this.parkingSpace = [];
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
        // this.$message.error('没有获取到车位信息')
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      load();
    }
  }

  /**
   * 获取结束时间，以及价格
   */
  @Watch('getSpaceList')
  onChangeGetSpaceList(newVal: any) {
    if (this.isSub) {
      this.monthCardCacuteTimeDebounce(this.filterParam.period || null, null);
    }
  }
  /**
   * 计算价格
   */
  private async monthCardCacuteTime(period: any, endDate: any) {
    if (this.isDetail) return;

    const load = this.$message.loading('正在计算价格', 0);
    try {
      const obj = this.monthCardPackage[this.filterParam.monthCardPackageIndex];
      if (!obj) throw new Error('没有月卡套餐');
      const { price, periodNum } = obj;
      const { startDate } = this.filterParam;
      const spaceCount = this.getSpaceList.length;
      const { status, data = {} } = await queryMonthCardCacuteTime({
        packagePrice: price,
        packagePeriod: periodNum,
        spaceCount,
        period: period || '',
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: endDate || ''
      });
      if (status === '9999') {
        const { endDate, price } = data;
        this.filterParam.endDate = endDate;
        this.filterParam.price = price;
      } else {
        this.filterParam.endDate = null;
        this.filterParam.price = 0;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || (error && error.message) || '系统繁忙，请稍后再试');
    } finally {
      load();
    }
  }

  /**
   * 添加车牌信息
   */
  private addAuthorizedVehiclesClick() {
    this.filterParam.plateList.push({
      checked: false,
      plate: this.defaultPlate || '',
      carType: '01',
      brand: '',
      color: '',
      masterCar: '00'
    });
  }

  /**
   * 删除车牌信息
   */
  private delAuthorizedVehicles(index: number) {
    this.filterParam.plateList.splice(index, 1);
  }

  /**
   * 过滤车位信息
   */
  private filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  // 当套餐变化
  @Watch('filterParam.monthCardPackageIndex')
  onChangeMonthCardPackageIndex(newVal: any) {
    if (newVal !== null && newVal !== undefined) {
      if (this.filterParam.cardId === '') {
        this.filterParam.packageId = this.monthCardPackage[newVal].packageId;
        this.filterParam.period = this.monthCardPackage[newVal].periodNum;
        this.spaceSelectList();
        this.monthCardCacuteTimeDebounce(this.filterParam.period, null);
      }
      this.validateData('packageId');
    } else {
      this.filterParam.packageId = '';
      this.parkingSpace = [];

      if (this.filterParam.useType === '01') {
        this.filterParam.spaceIdList = [];
      } else {
        this.filterParam.spaceId = '';
      }
    }
  }
  //遍历授权车辆 取消主车
  cancelMaster() {
    for (let i = 0; i < this.filterParam.plateList.length; i++) {
      this.filterParam.plateList[i].checked = false;
      this.filterParam.plateList[i].masterCar = '00';
    }
  }
  //根据车场获取是否启用优先车辆
  async getMasterSlave() {
    try {
      const { data } = await masterSlave({ parkId: this.filterParam.parkId });
      this.defaultMasterCar = data || '00';
    } catch (error) {
      this.$message.error((error && error.msg) || '未获取到是否启用优先车辆信息');
    }
  }
  //根据车场获取默认车牌所在地
  async getPlateNum() {
    try {
      const { data } = await getPlate({ parkId: this.filterParam.parkId });
      this.defaultPlate = data.plateHead || '';
      for (let i = 0; i < this.filterParam.plateList.length; i++) {
        // if (!this.filterParam.plateList[i].plate) {
        this.filterParam.plateList[i].plate = this.defaultPlate;
        // }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '未获取到该车场的默认车牌所在地');
    }
  }
  // 当车场发生变化
  @Watch('filterParam.parkId')
  onChangeParkId(newVal: any) {
    if (newVal) {
      if (this.filterParam.cardId === '') {
        this.spacePackageSelectList();
      }
      this.cancelMaster();
      this.getPlateNum();
      this.getMasterSlave();
    } else {
      this.monthCardPackage = [];
      this.parkingSpace = [];
      this.filterParam.monthCardPackageIndex = null;
      if (this.filterParam.useType === '01') {
        this.filterParam.spaceIdList = [];
      } else {
        this.filterParam.spaceId = '';
      }
    }
    this.form.setFieldsValue({
      roomNum: '',
      userName: '',
      phoneNum: ''
    });
    this.images = null;
  }
  //period
  @Watch('filterParam.period')
  onChangePeriod(newVal: any, oldVal: any) {
    if (newVal % this.filterParam.period === 0) {
      this.errorMsg.period.validateStatus = '';
      this.errorMsg.period.help = '';
      this.monthCardCacuteTimeDebounce(newVal, null);
    } else {
      this.filterParam.period = oldVal;
    }
  }

  /**
   * 看看cardId !== '' 的时候调用详情
   * @param date
   * @param dateString
   */

  @Watch('filterParam.cardId')
  onChangeCardId(newVal: any) {
    if (newVal !== '') {
      this.getMonthDetail();
    }
  }

  /**
   * 获取详情
   */
  async getMonthDetail() {
    try {
      const { cardId } = this.filterParam;
      const { status, msg, data = {} } = await quertMonthCardDetail({ cardId });

      if (status === '9999') {
        this.filterParam.cardId = data.cardId;
        this.filterParam.parkId = data.parkId;
        this.filterParam.packageId = data.spacePackage.packageId;
        this.filterParam.monthCardPackageIndex = 0;
        this.monthCardPackage = [data.spacePackage];
        // this.filterParam.spaceIdList = [data.spaceList[0].spaceId]

        data.spaceList.forEach((item: any) => {
          this.filterParam.spaceIdList.push(item.spaceId);
        });
        if (this.filterParam.spaceIdList.length === 1) {
          this.filterParam.spaceId = data.spaceList[0].spaceId;
        }
        this.parkingSpace = data.spaceList;
        this.filterParam.userName = data.spaceUser.userName;
        this.filterParam.userId = data.spaceUser.userId;
        this.filterParam.roomNum = data.spaceUser.roomNum;
        this.filterParam.company = data.spaceUser.company;
        this.filterParam.phoneNum = data.spaceUser.phoneNum;
        this.filterParam.cardNum = data.spaceUser.cardNum;
        this.filterParam.plateList = data.plateList;

        if (this.isDetail === true) {
          this.filterParam.endDate = data.endDate;
          this.filterParam.startDate = data.startDate;
          this.filterParam.payType = data.payType;
          this.filterParam.price = data.price;
        } else {
          this.filterParam.endDate = data.renewEndDate;
          this.filterParam.startDate = data.renewStartDate;
          this.filterParam.price = data.renewPrice;
        }
        this.filterParam.period = data.spacePackage.periodNum;
      } else {
        this.$message.error(msg);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  handleCheck(e: { target: { checked: any } }, index: string | number) {
    this.filterParam.plateList[index].checked = e.target.checked;
    if (this.checkedNum > this.getSpaceListNum) {
      this.$nextTick(() => {
        this.$set(this.filterParam.plateList[index], 'checked', false);
        this.filterParam.plateList[index].masterCar = this.filterParam.plateList[index].checked ? '01' : '00';
      });
      return this.$message.error(`最多勾选的主车数量不得超过产权车的泊车数量`);
    }
    this.filterParam.plateList[index].masterCar = this.filterParam.plateList[index].checked ? '01' : '00';
    this.$message.success(e.target.checked ? '主车设置成功' : '主车取消成功', 1);
  }
  // 时间变化
  onChangeTime(date: any, dateString: any) {
    const [startDate, endDate] = dateString;
    this.filterParam.startDate = startDate;
    this.filterParam.endDate = endDate;
    this.monthCardCacuteTime(null, endDate);
    this.validateData('startDate');
  }

  // 客户信息
  consList = [
    {
      title: '姓名',
      prop: 'consName',
      consName: ''
    },
    {
      title: '房号/住址',
      prop: 'consRoom',
      consRoom: ''
    },
    {
      title: '联系电话',
      prop: 'consTel',
      consTel: ''
    },
    {
      title: '身份证号',
      prop: 'consCardId',
      consCardId: ''
    }
  ];
  // 车位信息
  parkingInfo = [
    {
      prop: 'useType',
      label: '车位用途'
    },
    {
      prop: 'packageArea',
      label: '授权区域'
    },
    {
      prop: 'fixed',
      label: '是否固定车位'
    },
    {
      prop: 'period',
      label: '授权周期'
    },
    {
      prop: 'type',
      label: ' 卡类型'
    },
    {
      prop: 'price',
      label: ' 套餐单价'
    }
  ];
  goBack() {
    this.closeCurrentTab();
    this.$router.replace({
      name: PROPERTY_CAR_LIST
    });
  }
  //转化为大写
  changePlate(item: string, index: string | number) {
    this.filterParam.plateList[index].plate = item.trim().toLocaleUpperCase();
  }

  // 添加车位
  addStallvisitable = false;
  addItem() {
    // this.monthCardPackage[this.filterParam.monthCardPackageIndex].packageId
    if (this.filterParam.parkId === '' || this.monthCardPackage.length < 1) {
      return this.$message.warning('请选择车场或者套餐');
    } else {
      this.filterParam.packageId = this.monthCardPackage[this.filterParam.monthCardPackageIndex].packageId;
      this.addStallvisitable = true;
    }
  }
  handlecloseaddstall() {
    this.addStallvisitable = false;
  }

  spinning = false;
  onceAgen = 0;
  // 添加车位
  async addStailVal(values: any) {
    // @ts-ignore
    this.addstaillForm = values;
    if (this.spinning) return;
    this.spinning = true;
    try {
      const { data } = await queryParkingSpaceAddUpdate(values);
      this.$message.success('车位新增成功');
      this.addStallvisitable = false;
      // 刷新车位号
      this.spaceSelectList();
      ++this.onceAgen;
    } catch (error) {
      this.$message.error(error.msg || '新增失败');
      // this.addStallvisitable = false
    } finally {
      this.spinning = false;
    }
  }
  //上传图片
  detailDisabled: boolean = false;
  fileType: string = '03';
  images: any[] | null = null;
  API_SERVER = API_SERVER;
  showCount: number = 2;
  // 上传图片
  onUploadComplete(fileUrls: any[]) {
    // 新增和删除都会执行一次，在change后触发
    this.images = fileUrls;
  }
  filterOptionT(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  /**
   * 客户信息
   */
  handleUserChange(params) {
    this.form.setFieldsValue(params);
  }

  //数据变化时 数据校验
  validateData(type: string) {
    let { parkId, packageId, spaceIdList, spaceId, period, startDate, endDate, payType, waitingPay } = this.filterParam;

    if (this.filterParam.useType === '01') {
      if (spaceId) {
        spaceIdList.push(spaceId);
      }
    }
    spaceIdList = Array.from(new Set(spaceIdList));
    switch (type) {
      case 'parkId': {
        if (!parkId) {
          this.errorMsg.parkId.help = '车场必填';
          this.$message.error('车场必填');
          this.errorMsg.parkId.validateStatus = 'error';
        } else {
          this.errorMsg.parkId.help = '';
          this.errorMsg.parkId.validateStatus = '';
        }
        break;
      }
      // case 'phoneNum': {
      //   if (phoneNum && !/^(((1[0-9][0-9])\d{8}))$/.test(phoneNum)) {
      //     this.errorMsg.phoneNum.help = '请填写正确的手机号'
      //     this.$message.error('请填写正确的手机号')
      //     this.errorMsg.phoneNum.validateStatus = 'error'
      //   } else {
      //     this.errorMsg.phoneNum.help = ''
      //     this.errorMsg.phoneNum.validateStatus = ''
      //   }
      //   break
      // }
      case 'packageId': {
        if (!packageId) {
          this.errorMsg.packageId.help = '套餐必填';
          this.$message.error('套餐必填');
          this.errorMsg.packageId.validateStatus = 'error';
        } else {
          this.errorMsg.packageId.help = '';
          this.errorMsg.packageId.validateStatus = '';
        }
        break;
      }
      case 'spaceIdList': {
        if (spaceIdList.length === 0) {
          this.errorMsg.spaceId.help = '车位号必填';
          this.$message.error('车位号必填');
          this.errorMsg.spaceId.validateStatus = 'error';
        } else {
          this.errorMsg.spaceId.help = '';
          this.errorMsg.spaceId.validateStatus = '';
        }
        break;
      }
      case 'period': {
        if (!period) {
          this.errorMsg.period.help = '授权周期必填';
          this.$message.error('授权周期必填');
          this.errorMsg.period.validateStatus = 'error';
        } else {
          this.errorMsg.period.help = '';
          this.errorMsg.period.validateStatus = '';
        }
        break;
      }
      // case 'userName': {
      //   if (!userName) {
      //     this.errorMsg.userName.help = '姓名必填'
      //     this.$message.error('姓名必填')
      //     this.errorMsg.userName.validateStatus = 'error'
      //   } else if (!/^[\u4E00-\u9FA5A-Za-z0-9_]{1,15}$/.test(userName)) {
      //     this.errorMsg.userName.help = '姓名为中英文不得超过15个字符'
      //     this.$message.error('姓名为中英文且不超过15个字符')
      //     this.errorMsg.userName.validateStatus = 'error'
      //   } else {
      //     this.errorMsg.userName.help = ''
      //     this.errorMsg.userName.validateStatus = ''
      //   }
      //   break
      // }
      case 'startDate' || 'endDate': {
        if (!startDate || !endDate) {
          this.errorMsg.timeDate.help = '授权日期必填';
          this.$message.error('授权日期必填');
          this.errorMsg.timeDate.validateStatus = 'error';
        } else {
          this.errorMsg.timeDate.help = '';
          this.errorMsg.timeDate.validateStatus = '';
        }
        break;
      }
      case 'waitingPay': {
        if (!waitingPay) {
          this.errorMsg.waitingPay.help = '请选择支付场景';
          this.$message.error('请选择支付场景');
          this.errorMsg.waitingPay.validateStatus = 'error';
        } else {
          if (waitingPay == '02') {
            this.filterParam.payType = '';
          }
          this.errorMsg.waitingPay.help = '';
          this.errorMsg.waitingPay.validateStatus = '';
        }
        break;
      }
    }
  }
}
